export function applyTheme(theme = {}) {
  if (typeof document === 'undefined') return; 

  const root = document.documentElement;
  const primary = theme.primary || '#5062F0';
  const secondary = theme.secondary || '#454A67';

  const set = (name, value) => root.style.setProperty(name, value);

  const normalizeHex = (hex) => {
    const h = String(hex).replace('#', '');
    return h.length === 3 ? [...h].map((c) => c + c).join('') : h;
  };

  const toRgb = (hex) => {
    const full = normalizeHex(hex);
    const r = parseInt(full.slice(0, 2), 16);
    const g = parseInt(full.slice(2, 4), 16);
    const b = parseInt(full.slice(4, 6), 16);
    return `${r} ${g} ${b}`;
  };

  const pickTextContrast = (hex) => {
    const full = normalizeHex(hex);
    const r = parseInt(full.slice(0, 2), 16);
    const g = parseInt(full.slice(2, 4), 16);
    const b = parseInt(full.slice(4, 6), 16);
    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 140 ? '#111111' : '#ffffff';
  };

  set('--theme-primary', primary);
  set('--theme-secondary', secondary);
  set('--theme-primary-rgb', toRgb(primary));
  set('--theme-secondary-rgb', toRgb(secondary));
  set('--theme-primary-contrast', pickTextContrast(primary));
  set('--theme-secondary-contrast', pickTextContrast(secondary));
}

export default applyTheme;
